<template>
  <v-row>
    <v-col
        cols="12"
    >
      <h3>
        Bonusy
      </h3>

      <p>
        {{ Wage.priceBonuses|currency('€') }}

        <template
            v-if="Wage.priceBonusesBank || Wage.priceBonusesCash"
        >
          <br/>

          <small>
            <template
                v-if="Wage.priceBonusesBank"
            >
              <v-icon
                  color="primary"
              >
                mdi-bank-transfer
              </v-icon>

              {{ Wage.priceBonusesBank|currency('€') }}
            </template>

            <template
                v-if="Wage.priceBonusesCash"
            >
              <v-icon
                  color="primary"
              >
                mdi-cash
              </v-icon>

              {{ Wage.priceBonusesCash|currency('€') }}
            </template>
          </small>
        </template>
      </p>

      <IsEmptyHelper
          :value="Wage.wageTicketBonuses.length > 0"
          if-no="table"
          if-yes="p"
          :no-gutters="true"
      >
        <thead>
          <tr>
            <th
                width="2.5%"
            >
              <v-checkbox
                  v-model="all"
                  :dense="true"
                  hide-details="auto"
                  @change="(value) => {
                    ids = []

                    total = 0

                    if (value) {
                      Wage.wageTicketBonuses.forEach((_WageTicketBonus) => {
                        ids.push(_WageTicketBonus.TicketBonus.id)

                        total += _WageTicketBonus.price
                      })
                    }
                  }"
              />
            </th>

            <th
                width="10%"
                align="left"
            >
              Vykonanie
            </th>

            <th
                width="17.5%"
                align="left"
            >
              Projekt
            </th>

            <th
                width="20%"
                align="left"
            />

            <th
                width="10%"
                align="left"
            >
              Suma
            </th>

            <th
                width="10%"
                align="left"
            >
              Stav
            </th>

            <th
                width="7.5%"
                align="left"
            >
              Uhradenie
            </th>

            <th
                width="7.5%"
                align="left"
            >
              Platba
            </th>

            <th
                width="15%"
                align="left"
            >
              Účet
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
              v-for="(_WageTicketBonus) in Wage.wageTicketBonuses"
              :key="_WageTicketBonus.TicketBonus.id"
              valign="top"
          >
            <td>
              <v-checkbox
                  v-model="ids"
                  :value="_WageTicketBonus.TicketBonus.id"
                  :dense="true"
                  hide-details="auto"
                  @change="() => {
                    if (ids.length === Wage.wageTicketBonuses.length) {
                      all = true
                    } else {
                      all = false
                    }

                    if (ids.includes(_WageTicketBonus.TicketBonus.id)) {
                      total += _WageTicketBonus.price
                    } else {
                      total -= _WageTicketBonus.price
                    }
                  }"
              />
            </td>

            <td>
              {{ _WageTicketBonus.workedAt|moment('DD.MM.YYYY') }}
            </td>

            <td>
              {{ _WageTicketBonus.currentProjectTitle }}
            </td>

            <td/>

            <td>
              {{ _WageTicketBonus.price|currency('€') }}
            </td>

            <td>
              {{ statusList[_WageTicketBonus.status]?.text }}
            </td>

            <td>
              <IsEmptyHelper
                  :value="_WageTicketBonus.paidAt"
                  if-no="span"
                  if-yes="span"
              >
                {{ _WageTicketBonus.paidAt|moment('DD.MM.YYYY') }}
              </IsEmptyHelper>
            </td>

            <td>
              <IsEmptyHelper
                  :value="_WageTicketBonus.pay"
                  if-no="span"
                  if-yes="span"
              >
                {{ payList[_WageTicketBonus.pay]?.text }}
              </IsEmptyHelper>
            </td>

            <td>
              <IsEmptyHelper
                  :value="_WageTicketBonus.accountBillingName"
                  if-no="span"
                  if-yes="span"
              >
                {{ _WageTicketBonus.accountBillingName }}
              </IsEmptyHelper>
            </td>
          </tr>
        </tbody>

        <tfoot
            v-if="ids.length > 0"
        >
          <tr>
            <th
                align="left"
            >
              <UpdateMassTicketBonus
                  :x-small="true"
                  :closingId="Wage.Closing.id"
                  :ids="ids"
                  @onUpdateMass="$emit('refresh')"
              />
            </th>

            <th
                align="left"
                :colspan="3"
            />

            <th
                align="left"
            >
              {{ total|currency('€') }}
            </th>

            <th
                align="left"
                :colspan="4"
            />
          </tr>
        </tfoot>
      </IsEmptyHelper>
    </v-col>
  </v-row>
</template>

<script>
  import UpdateMassTicketBonus from '@/components/TicketBonuses/UpdateMass'

  import IsEmptyHelper from '@/components/_Part/_Helper/IsEmpty'

  export default {
    name: 'TicketBonuses',
    props: [
      'Wage'
    ],
    emits: [
      'refresh'
    ],
    components: {
      UpdateMassTicketBonus,
      IsEmptyHelper
    },
    data() {
      return {
        all: false,
        ids: [],
        total: 0
      }
    },
    computed: {
      statusList: function () {
        return this.$store.state.core.Entity.WageTicketBonus?.status
      },
      payList: function () {
        return this.$store.state.core.Entity.WageTicketBonus?.pay
      }
    }
  }
</script>
